export enum MutationAuthorizations {
  MutazioneMatrimonio = 'MUTAZIONE.MATRIMONIO.INS',
  RegistrazioneCittadinanza = 'MUTAZIONE.CITTADINANZA.INS',
  MutazioneVedovanza = 'MUTAZIONE.VEDOVANZA.INS',
  AnnullamentoMatrimonio = 'ANNULLAMENTO.MATRIMONIO.ANPR.INS',
  MutazioneConvivenza = 'MUTAZIONE.CONVIVENZA.INS',
  RegistrazioneDiffida = 'MUTAZIONE.DIFFIDE.INS',
  RegistrazioneAnomalie = 'MUTAZIONE.ANOMALIE.INS',
  AggiornamentoParentela = 'MUTAZIONE.FAMIGLIA.AGG',
  InserimentoUnioneCivile = 'MUTAZIONE.UNIONECIVILE.INS',
}

export const MarriageMenuAuthorization = [MutationAuthorizations.MutazioneMatrimonio];

export const RegistrationCivilUnionAuthorization = [MutationAuthorizations.InserimentoUnioneCivile];

export const CancelCivilUnionAuthorization = [MutationAuthorizations.InserimentoUnioneCivile];

export const WidowhoodMenuAuthorization = [MutationAuthorizations.MutazioneVedovanza];

export const CancelMarriageAuthorizations = [MutationAuthorizations.AnnullamentoMatrimonio];

export const CohabitationMutationAuthorizations = [MutationAuthorizations.MutazioneConvivenza];

export const RegistrationCitizenshipAuthorizations = [
  MutationAuthorizations.RegistrazioneCittadinanza,
];

export const RegistrationBewareAuthorizations = [MutationAuthorizations.RegistrazioneDiffida];

export const RegistrationAnomalyAuthorizations = [MutationAuthorizations.RegistrazioneAnomalie];

export const UpdateParenthoodAuthorizations = [MutationAuthorizations.AggiornamentoParentela];

export const MutationAuthorizationsList = [
  ...MarriageMenuAuthorization,
  ...WidowhoodMenuAuthorization,
  ...CancelMarriageAuthorizations,
  ...RegistrationCitizenshipAuthorizations,
  ...CohabitationMutationAuthorizations,
  ...RegistrationBewareAuthorizations,
  ...UpdateParenthoodAuthorizations,
  ...RegistrationCivilUnionAuthorization,
  ...CancelCivilUnionAuthorization,
  ...RegistrationAnomalyAuthorizations,
];
